<template>
    <main>
        <!-- Modal -->
        <modalCreate :usuario="usuario" :idUsuario="idUsuario" ref="createCertificate" v-on:last-certificate="getLastCertificate(idUsuario)"></modalCreate>  
        <!-- Modal -->
        <modalList :certificates="certificates" :usuario="usuario" :idUsuario="idUsuario" ref="listCertificate" v-on:last-certificate="getLastCertificate(idUsuario)"></modalList>  
        <div class="card-header bg-light border-bottom-0">
            <div class="row align-items-center w-100">
                <div class="col-6 font-weight-bold text-gray-600 h6 mb-0">
                    <i class="fas fa-file-signature mr-2"></i> C. Médicos 
                </div>
                <div class="col-6 d-flex justify-content-end">
                    <button class="btn btn-primary btn-xs btn-icon" type="button" @click="newCertificate();" v-if="_can('certificate.create')">
                        <i class="fas fa-plus"></i>
                    </button>           
                </div>
            </div>
        </div>
        <div class="card-body">
            <div class="d-flex justify-content-between align-items-center mb-2">
                    <span class="text-muted small font-weight-bold">Última Certificado</span>
                    <span v-if="Object.keys(lastCertificate).length" class="text-bold font-weight-bold">{{lastCertificate.date_certificate | formatDate}} {{lastCertificate.hour_certificate | timeFormat}}</span>
                    <span v-else class="badge badge-light text-danger font-italic small">Sin datos...</span>
                </div>
            <button @click="historyCertificates();" type="button" class="btn btn-light btn-sm btn-block text-primary font-weight-bold mt-2">Ver Certificado <i class="far fa-eye fa-fw"></i></button>                
        </div>
    </main>
</template>
<script>

import medicalCertificateService from '../../../../services/medicalCertificateService';
import modalCreate from "./modalCreate";
import modalList from "./modalList";
export default {
    props: ['idUsuario', 'usuario'],
    components:{modalCreate,modalList},
    data(){
        return {
            certificates:{},
            lastCertificate:{},
            id_usuario: '',
        }
    },
    methods: { 
        async getLastCertificate(id){
            const response = await medicalCertificateService.showByLast(id);
            this.lastCertificate= response.data;
        },
        async historyCertificates(){
            this.$refs.listCertificate.open();
        },
        async newCertificate(){
            this.$refs.createCertificate.open();
        },
    },
    watch:{
        idUsuario(){
            this.getLastCertificate(this.idUsuario);
        }
    },
    async created() {
        await this.getLastCertificate(this.idUsuario);
       
    }
}
</script>